import React, { useContext } from 'react';

import BasePane from '@totem/components/BasePane';
import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import ZoneMappingContainer from '@totem/components/settings/sections/nozomi/zoneMappings/ZoneMappingContainer';
import ZoneMappingTable from '@totem/components/settings/sections/nozomi/zoneMappings/ZoneMappingTable';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import PrimaryContentPane from '@totem/components/ui_components/page/PrimaryContentPane';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const ZoneMappingPage = () => {
  const { userProfile } = useContext(UserProfileContext);

  return (
    <ContentLayout>
      <BasePane>
        <PrimaryContentPane>
          {permissions.systemAdministrator.hasPermissions(userProfile) && (
            <IBTooltip content={permissions.systemAdministrator.tooltip}>
              <ZoneMappingContainer>
                <ZoneMappingTable />
              </ZoneMappingContainer>
            </IBTooltip>
          )}
        </PrimaryContentPane>
      </BasePane>
    </ContentLayout>
  );
};

export default ZoneMappingPage;
